var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 59,
    viewBox: "0 0 52 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 28.5C16.9477 28.5 16.5 28.9477 16.5 29.5C16.5 30.0523 16.9477 30.5 17.5 30.5V29.5V28.5ZM35.2071 30.2071C35.5976 29.8166 35.5976 29.1834 35.2071 28.7929L28.8431 22.4289C28.4526 22.0384 27.8195 22.0384 27.4289 22.4289C27.0384 22.8195 27.0384 23.4526 27.4289 23.8431L33.0858 29.5L27.4289 35.1569C27.0384 35.5474 27.0384 36.1805 27.4289 36.5711C27.8195 36.9616 28.4526 36.9616 28.8431 36.5711L35.2071 30.2071ZM17.5 29.5V30.5H34.5V29.5V28.5H17.5V29.5Z",
    fill: "#8C8C8C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.c3e371d74066b596ab861d45b1e59460.svg";
export { ForwardRef as ReactComponent };